// src/components/Leaderboard.js
import React, { useEffect, useState } from 'react';
import { database } from '../firebase';
import { ref, onValue } from 'firebase/database';
import { emptyLeaderboard } from '../lib/copy';

const Leaderboard = () => {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const recordsToShow = 10; // Number of records to display

  useEffect(() => {
    const dbRef = ref(database, 'dailyBestScores');

    const unsubscribe = onValue(dbRef, (snapshot) => {
      const data = [];
      snapshot.forEach((childSnapshot) => {
        data.push({ id: childSnapshot.key, ...childSnapshot.val() });
      });

      // Sort by best score, highest first
      data.sort((a, b) => (b.bestScore || 0) - (a.bestScore || 0));

      setLeaderboardData(data.slice(0, recordsToShow)); // Limit to X records
    });

    return () => unsubscribe();
  }, []);

  const medals = ['🥇', '🥈', '🥉'];

  return (
    <div className="sg-card" style={{ marginTop: 20 }}>
      <div className="sg-stack" style={{ gap: 2, marginBottom: 16 }}>
        <span className="sg-kicker">Daily leaderboard</span>
        <h3 style={{ margin: 0, fontSize: '1.35rem' }}>Top scores today</h3>
      </div>

      {leaderboardData.length === 0 ? (
        <p className="sg-faint" style={{ margin: 0 }}>{emptyLeaderboard}</p>
      ) : (
        <div className="sg-stack sg-stagger" style={{ gap: 8 }}>
          {leaderboardData.map((entry, index) => {
            const rank = index + 1;
            const isLead = rank === 1;
            return (
              <div
                key={entry.id}
                className="sg-row"
                style={{
                  gap: 12,
                  padding: '10px 12px',
                  borderRadius: 'var(--r-md)',
                  background: isLead
                    ? 'color-mix(in srgb, var(--sunshine) 22%, var(--surface))'
                    : 'var(--surface)',
                  boxShadow: isLead
                    ? 'inset 0 0 0 2px color-mix(in srgb, var(--sunshine) 70%, transparent)'
                    : 'inset 0 0 0 1px rgba(42, 33, 64, 0.06)',
                }}
              >
                <div style={{ width: 36, flexShrink: 0, textAlign: 'center' }}>
                  {rank <= 3 ? (
                    <span style={{ fontSize: '1.5rem', lineHeight: 1 }}>{medals[rank - 1]}</span>
                  ) : (
                    <span className={`sg-badge${isLead ? ' sg-badge--lead' : ''}`}>#{rank}</span>
                  )}
                </div>

                <div className="sg-stack" style={{ gap: 2, flex: 1, minWidth: 0 }}>
                  <span
                    style={{
                      fontWeight: 800,
                      fontSize: '1rem',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {entry.playerName}
                  </span>
                  <span className="sg-faint" style={{ fontSize: '0.78rem' }}>
                    {entry.windowSize}×{entry.poolSize} · {entry.dateString}
                  </span>
                </div>

                <span
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: '1.6rem',
                    lineHeight: 1,
                    color: isLead ? 'var(--tangerine)' : 'var(--ink)',
                    flexShrink: 0,
                  }}
                >
                  {entry.bestScore}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Leaderboard;
